import { WifiOff } from 'lucide-react'
import { useNetworkStore } from '@/lib/store/useNetworkStore'

export function OfflineIndicator() {
  const isOnline = useNetworkStore((s) => s.isOnline)
  if (isOnline) return null
  return (
    <div className="flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-yellow-500/15 border border-yellow-500/30 text-yellow-400 text-xs font-medium">
      <WifiOff className="h-3 w-3" />
      Offline
    </div>
  )
}
